import { render } from "./prescription.vue?vue&type=template&id=16f6b7e9&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=16f6b7e9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f6b7e9"]])

export default __exports__